/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import { inject as service } from '@ember/service';
import SigningSecretModel from 'cio/models/signing-secret';
import AlertsService from 'cio/services/alerts';
import DS from 'ember-data';

interface WebhookSigningKeyArgs {
  signingKey: SigningSecretModel;
  readOnly: boolean;
  environmentId?: string;
}

export default class WebhookSigningKey extends Component<WebhookSigningKeyArgs> {
  @service alerts!: AlertsService;
  @service store!: DS.Store;

  get isRegenerateSigningKeyDisabled() {
    return this.regenerateSigningKey.isRunning;
  }
  regenerateSigningKey = task({ drop: true }, async () => {
    try {
      await this.args.signingKey.regenerateSigningKey({});
    } catch {
      this.alerts.error(
        'workspace-settings.webhook-signing-key.error',
        'We ran into an issue creating a new signing key. Please try again.',
      );
    }
  });
}
